import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

export class ScrollToTop extends React.Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        children: PropTypes.object.isRequired,
    };

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);
